import { createContext } from 'react';


// @ts-ignore
export const Context = createContext();